import { useEffect, useState } from "react";
import TableResponsive from "../TableResponsive";
import useFormat from "../../hooks/utils/useFormat";
import LabelType from "../LabelType";
import useWrapper from "../../hooks/useWrapper";
import connection from "../../services/ws";
import { toast } from "react-toastify";
import Button from "../Button";
import { listAttendances } from "../../hooks/api/listAttendance";
import Pagenation from "../Pagenation";
import Loading from "../Loading";

export default function AttendanceTable(props) {
  const { url_type, query, applyFilter, filter, attendances, setattendances, commercial_id, trainee_id } = props;
  const { me, token, config } = useWrapper();
  const { formatDate, formatName } = useFormat();

  const [isLoadingAttendances, setisLoadingAttendances] = useState(true);
  const [refresh, setrefresh] = useState();

  const hide_paginate = query?.includes("paginate=false");

  const ws_channel =
    url_type === "group"
      ? `attendance-notification-commercial:${commercial_id}`
      : url_type === "trainee" || url_type === "trainee_area"
      ? `attendance-notification-trainee:${trainee_id}`
      : "attendance-notification";

  useEffect(() => {
    if (!!refresh) getAttendances();
  }, [refresh]);
  useEffect(() => {
    if (query !== undefined) getAttendances();
  }, [query]);

  async function getAttendances() {
    try {
      setisLoadingAttendances(true);
      let _attendances = await listAttendances({
        config,
        me,
        query,
      });
      setattendances(_attendances || []);
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar carregar os atendimentos.");
    } finally {
      setisLoadingAttendances(false);
    }
  }

  const [isConnected, setisConnected] = useState(false);
  useEffect(() => {
    if (!isConnected && attendances) {
      try {
        connection.connect(token);
        connection.subscribe(ws_channel, handleWS);
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Erro ao tentar se conectar ao atendimento.");
      } finally {
        // return () => {
        //   connection.disconnect();
        // };
        setisConnected(true);
      }
    }
  }, [attendances]);

  const [hasUpdate, sethasUpdate] = useState();

  function handleWS(__message) {
    const { type, data } = __message;
    if (type === "socket-attendance:changeList") {
      sethasUpdate(true);
    }
    return;
  }

  return (
    <>
      {!isLoadingAttendances ? (
        <>
          {!!hasUpdate && (
            <Button
              color="grey"
              onClick={() => {
                setrefresh(new Date());
                sethasUpdate(false);
              }}
              className="w-100 mb-4"
            >
              Mostrar Atualizações Recentes
            </Button>
          )}
          <TableResponsive
            table={{
              head: [
                { data: "Protocolo" },
                ...(me?.type === "Gestor" && url_type !== "trainee"
                  ? [
                      {
                        data: "Formando",
                      },
                    ]
                  : []),
                { data: "Categoria" },
                { data: "Atualização" },
                { data: <div className="d-flex justify-content-end">Atendente</div> },
              ],
              body:
                attendances?.data?.map(
                  __attendance =>
                    ({
                      bold:
                        (!__attendance?.read && me?.type === "Gestor") ||
                        (!__attendance?.read_trainee && me?.type === "Formando"),
                      link:
                        url_type === "trainee_area"
                          ? `/formando-dashboard/atendimento/mensagem/${__attendance.id}`
                          : url_type === "group"
                          ? `/groups/${__attendance?.commercial_id}/attendance/${__attendance?.id}`
                          : url_type === "trainee"
                          ? `/trainees/attendance/${__attendance?.trainee_id}/${__attendance?.id}`
                          : `/attendance/edit/${__attendance?.id}`,
                      data: [
                        {
                          element: (
                            <LabelType colorScheme={__attendance?.status}>
                              {__attendance?.id}
                              {__attendance.commission_only ? (
                                <p className="small-label m-0 mb-1 text-center">
                                  <b>(Comissão)</b>
                                </p>
                              ) : (
                                ""
                              )}
                            </LabelType>
                          ),
                        },
                        ...(me?.type === "Gestor" && url_type !== "trainee"
                          ? [
                              {
                                element: (
                                  <>
                                    {__attendance?.trainee?.name || "-"}
                                    {__attendance?.commercial ? (
                                      <p className="small-label m-0">
                                        {`${__attendance?.commercial?.course?.title} ${
                                          __attendance?.commercial?.institution?.title
                                        } ${__attendance?.commercial?.year}.${__attendance?.commercial?.period}${
                                          !__attendance?.commercial?.contract_number_legacy
                                            ? ""
                                            : ` - ${__attendance?.commercial?.contract_number_legacy || "?"}`
                                        }` || "-"}
                                      </p>
                                    ) : (
                                      <p className="small-label m-0">?</p>
                                    )}
                                  </>
                                ),
                              },
                            ]
                          : []),
                        {
                          element: (
                            <>
                              {__attendance?.category?.name || "-"}
                              <p className="small-label m-0">{__attendance?.resource?.name || "-"}</p>
                            </>
                          ),
                        },
                        {
                          element: (
                            <>
                              {formatDate(__attendance?.modified_at, 2)}
                              <p className="small-label m-0">{formatDate(__attendance?.modified_at, 6)}</p>
                            </>
                          ),
                        },
                        {
                          element: (
                            <div className="d-flex justify-content-end">
                              {formatName(__attendance?.user?.username) || "-"}
                            </div>
                          ),
                        },
                      ],
                    } || []),
                ) || [],
            }}
          />
          {!hide_paginate && (
            <Pagenation
              current={attendances?.page}
              total={attendances?.lastPage}
              pageChange={__page => {
                applyFilter({
                  ...filter,
                  page: __page,
                });
              }}
              className="mt-4"
            />
          )}
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}
